import React from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { NoResultsFound } from 'shared/ui/NoResultsFound/NoResultsFound'
import { CallHistoryTable } from 'pages/conversations/pages/calls/ui/CallHistoryTable'
import { useCallHistoryContext } from 'pages/conversations/pages/calls/ui/CallHistory/context/callHistoryContext'
import { CallHistoryHeader } from 'pages/conversations/pages/calls/ui/CallHistory/ui/web/CallHistoryHeader/CallHistoryHeader'
import { WebEmptyStateCallHistory } from 'pages/conversations/pages/calls/ui/CallHistory/ui/web/WebEmptyStateCallHistory/WebEmptyStateCallHistory'
import styles from './styles.module.scss'

export const CallHistoryWebContent = observer(() => {
  const store = useCallHistoryContext()
  const { isEmptyState, isEmptySearchResults, isLoading, isLoadingStatistics } = store
  if (isEmptyState) {
    return <WebEmptyStateCallHistory />
  }
  return (
    <div className={styles.wrap}>
      <CallHistoryHeader />
      {(isLoadingStatistics || isLoading) && <SpinnerLoader ariaLabel={'CallHistoryWebContent'} />}
      {!isLoadingStatistics &&
        !isLoading &&
        (isEmptySearchResults ? <NoResultsFound /> : <CallHistoryTable callHistoryStore={store} />)}
    </div>
  )
})
